var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "company-create-dialog",
      attrs: {
        visible: _vm.isVisible,
        title: _vm.dialogTitle,
        size: "small",
        closeOnClickOverlay: false
      },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        },
        closed: _vm.close
      },
      scopedSlots: _vm._u(
        [
          !_vm.requestSent
            ? {
                key: "footer",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "company-create-dialog__footer" },
                      [
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__("common.actions.cancel"),
                            type: "secondary"
                          },
                          on: { click: _vm.handleCancel }
                        }),
                        _vm._v(" "),
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__("common.actions.save"),
                            disabled: _vm.isLoadingCustomFields
                          },
                          on: { click: _vm.handleSave }
                        })
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            : null
        ],
        null,
        true
      )
    },
    [
      !_vm.requestSent && !_vm.companyCreateError
        ? [
            _c(
              "div",
              { staticClass: "company-create-dialog__form" },
              [
                _c(
                  "CompassFormItem",
                  {
                    attrs: {
                      label: _vm.form.labels.companyName,
                      required: "",
                      requiredLabel: _vm.$t.__("common.labels.required")
                    }
                  },
                  [
                    _c("CompassInput", {
                      attrs: { disabled: _vm.isLoadingCustomFields },
                      model: {
                        value: _vm.form.values.companyName,
                        callback: function($$v) {
                          _vm.$set(_vm.form.values, "companyName", $$v)
                        },
                        expression: "form.values.companyName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isFrench
                  ? _c(
                      "CompassFormItem",
                      {
                        attrs: {
                          label: _vm.form.labels.companyRegistration,
                          required: _vm.isFrench,
                          requiredLabel: _vm.$t.__("common.labels.required")
                        }
                      },
                      [
                        _c("CompassInput", {
                          attrs: { disabled: _vm.isLoadingCustomFields },
                          model: {
                            value: _vm.form.values.companyRegistration,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form.values,
                                "companyRegistration",
                                $$v
                              )
                            },
                            expression: "form.values.companyRegistration"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAddress && !_vm.isLoadingCountries
                  ? [
                      _c(
                        "CompassFormItem",
                        {
                          attrs: {
                            label: _vm.form.labels.address.label,
                            required: "",
                            requiredLabel: _vm.$t.__("common.labels.required"),
                            error: _vm.form.labels.address.labelError
                          }
                        },
                        [
                          _c("CompassInput", {
                            attrs: {
                              error: _vm.form.labels.address.labelError !== ""
                            },
                            model: {
                              value: _vm.form.values.address.label,
                              callback: function($$v) {
                                _vm.$set(_vm.form.values.address, "label", $$v)
                              },
                              expression: "form.values.address.label"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "CompassFormItem",
                        {
                          attrs: {
                            label: _vm.form.labels.address.line1,
                            required: "",
                            requiredLabel: _vm.$t.__("common.labels.required"),
                            error: _vm.form.labels.address.line1Error
                          }
                        },
                        [
                          _c("CompassInput", {
                            attrs: {
                              error: _vm.form.labels.address.line1Error !== ""
                            },
                            model: {
                              value: _vm.form.values.address.line1,
                              callback: function($$v) {
                                _vm.$set(_vm.form.values.address, "line1", $$v)
                              },
                              expression: "form.values.address.line1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "CompassFormItem",
                        { attrs: { label: _vm.form.labels.address.line2 } },
                        [
                          _c("CompassInput", {
                            model: {
                              value: _vm.form.values.address.line2,
                              callback: function($$v) {
                                _vm.$set(_vm.form.values.address, "line2", $$v)
                              },
                              expression: "form.values.address.line2"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "company-create-dialog__form-column" },
                        [
                          _c(
                            "CompassFormItem",
                            {
                              staticClass: "postal-code",
                              attrs: {
                                label: _vm.form.labels.address.postalCode,
                                required: "",
                                requiredLabel: _vm.$t.__(
                                  "common.labels.required"
                                ),
                                error: _vm.form.labels.address.postalCodeError
                              }
                            },
                            [
                              _c("CompassInput", {
                                attrs: {
                                  error:
                                    _vm.form.labels.address.postalCodeError !==
                                    ""
                                },
                                model: {
                                  value: _vm.form.values.address.postalCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.values.address,
                                      "postalCode",
                                      $$v
                                    )
                                  },
                                  expression: "form.values.address.postalCode"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "CompassFormItem",
                            {
                              staticClass: "city",
                              attrs: {
                                label: _vm.form.labels.address.city,
                                required: "",
                                requiredLabel: _vm.$t.__(
                                  "common.labels.required"
                                ),
                                error: _vm.form.labels.address.cityError
                              }
                            },
                            [
                              _c("CompassInput", {
                                attrs: {
                                  error:
                                    _vm.form.labels.address.cityError !== ""
                                },
                                model: {
                                  value: _vm.form.values.address.city,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.values.address,
                                      "city",
                                      $$v
                                    )
                                  },
                                  expression: "form.values.address.city"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "CompassFormItem",
                        {
                          attrs: {
                            label: _vm.form.labels.address.country,
                            required: "",
                            requiredLabel: _vm.$t.__("common.labels.required")
                          }
                        },
                        [
                          _c(
                            "CompassSelect",
                            {
                              attrs: { menuClass: "company-create-select" },
                              model: {
                                value: _vm.form.values.address.country,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.values.address,
                                    "country",
                                    $$v
                                  )
                                },
                                expression: "form.values.address.country"
                              }
                            },
                            _vm._l(_vm.form.countries, function(country) {
                              return _c("CompassDropdownSelectOption", {
                                key: country.code,
                                attrs: {
                                  label: country.name,
                                  value: country.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAddress && _vm.isLoadingCountries
                  ? [
                      _c("CompassSkeleton", { staticClass: "skeleton__label" }),
                      _vm._v(" "),
                      _c("CompassSkeleton", {
                        staticClass: "skeleton__input skeleton__input--spacer",
                        attrs: { size: "large" }
                      }),
                      _vm._v(" "),
                      _c("CompassSkeleton", { staticClass: "skeleton__label" }),
                      _vm._v(" "),
                      _c("CompassSkeleton", {
                        staticClass: "skeleton__input",
                        attrs: { size: "large" }
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "CompassFormItem",
                  { attrs: { label: _vm.form.labels.companyType } },
                  [
                    _c(
                      "CompassSelect",
                      {
                        attrs: {
                          disabled: _vm.isLoadingCustomFields,
                          menuClass: "company-create-select"
                        },
                        model: {
                          value: _vm.form.values.companyType,
                          callback: function($$v) {
                            _vm.$set(_vm.form.values, "companyType", $$v)
                          },
                          expression: "form.values.companyType"
                        }
                      },
                      _vm._l(_vm.companyTypes, function(item) {
                        return _c("CompassDropdownSelectOption", {
                          key: item.value,
                          attrs: {
                            label: item.label,
                            value: item.value,
                            type: "dot",
                            dotColor: item.dotColor
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _vm.isLoadingCustomFields
              ? [
                  _c("CompassSkeleton", { staticClass: "skeleton__title" }),
                  _vm._v(" "),
                  _c("CompassSkeleton", { staticClass: "skeleton__label" }),
                  _vm._v(" "),
                  _c("CompassSkeleton", {
                    staticClass: "skeleton__input skeleton__input--spacer",
                    attrs: { size: "large" }
                  }),
                  _vm._v(" "),
                  _c("CompassSkeleton", { staticClass: "skeleton__label" }),
                  _vm._v(" "),
                  _c("CompassSkeleton", {
                    staticClass: "skeleton__input",
                    attrs: { size: "large" }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            !!_vm.requiredCustomFieldsByType.length
              ? [
                  _c(
                    "h3",
                    {
                      staticClass:
                        "typographies-heading-h3 company-create-dialog__title"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$l10n.__("Champs personnalisés obligatoires")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "company-create-dialog__form" },
                    _vm._l(_vm.requiredCustomFieldsByType, function(field) {
                      return _c(
                        "CompassFormItem",
                        {
                          key: field.id,
                          class: field.error ? "is-error" : "",
                          attrs: {
                            label: field.name,
                            info: field.description,
                            error: field.error || "",
                            required: "",
                            requiredLabel: _vm.$t.__("common.labels.required")
                          }
                        },
                        [
                          _c("cf-" + field.type, {
                            tag: "component",
                            attrs: {
                              id: field.id,
                              parameters: field.parameters,
                              value: field.value,
                              type: field.type
                            },
                            on: { input: _vm.updateValue }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.companyCreateError
        ? _c("CompassAlert", {
            staticClass: "company-create-dialog__alert",
            attrs: {
              type: "error",
              description: _vm.alertText,
              showIcon: "",
              showClose: false
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.requestSent && !_vm.companyCreateError
        ? [
            _c("CompassLoader", {
              staticClass: "company-create-dialog__loader"
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }